import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("legend", null, "DatetimePicker", -1);
const _hoisted_2 = { class: "row" };
const _hoisted_3 = { class: "col-sm-4" };
const _hoisted_4 = { class: "col-sm-4" };
const _hoisted_5 = { class: "col-sm-4" };
const _hoisted_6 = { class: "col-sm-4" };
const _hoisted_7 = { class: "col-sm-4" };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("legend", null, "select-2", -1);
const _hoisted_9 = { class: "row" };
const _hoisted_10 = { class: "col-sm-6" };
const _hoisted_11 = { class: "row" };
const _hoisted_12 = { class: "col-sm-8" };
const _hoisted_13 = { class: "col-sm-4" };
const _hoisted_14 = { class: "col-sm-6" };
const _hoisted_15 = { class: "row" };
const _hoisted_16 = { class: "col-sm-8" };
const _hoisted_17 = { class: "col-sm-4" };
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("legend", null, "VToggle", -1);
const _hoisted_19 = /*#__PURE__*/ _createElementVNode("legend", null, "SummernoteEditor", -1);
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("h4", null, "Simples", -1);
const _hoisted_21 = { class: "row" };
const _hoisted_22 = { class: "col-sm-6" };
const _hoisted_23 = { class: "col-sm-6" };
const _hoisted_24 = /*#__PURE__*/ _createElementVNode("h4", null, "Model:", -1);
const _hoisted_25 = { class: "row" };
const _hoisted_26 = { class: "col-sm-6" };
const _hoisted_27 = /*#__PURE__*/ _createElementVNode("legend", null, "Variaveis Template", -1);
const _hoisted_28 = { class: "col-sm-12" };
const _hoisted_29 = { class: "col-sm-6" };
const _hoisted_30 = /*#__PURE__*/ _createElementVNode("legend", null, "Decimais e moedas", -1);
const _hoisted_31 = { class: "row" };
const _hoisted_32 = { class: "col-sm-4" };
const _hoisted_33 = { class: "input-groupd" };
const _hoisted_34 = { class: "input-group" };
const _hoisted_35 = { class: "col-sm-4" };
const _hoisted_36 = { class: "col-sm-4" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_DatetimePicker = _resolveComponent("DatetimePicker");
    const _component_Select2 = _resolveComponent("Select2");
    const _component_VToggle = _resolveComponent("VToggle");
    const _component_SummernoteEditor = _resolveComponent("SummernoteEditor");
    const _component_VariaveisTemplate = _resolveComponent("VariaveisTemplate");
    const _directive_input_format = _resolveDirective("input-format");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("fieldset", null, [
            _hoisted_1,
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("h4", null, "Data/Hora: " + _toDisplayString(_ctx.datetimepicker.dthr), 1),
                    _createElementVNode("div", null, [
                        _createVNode(_component_DatetimePicker, {
                            modelValue: _ctx.datetimepicker.dthr,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.datetimepicker.dthr) = $event))
                        }, null, 8, ["modelValue"])
                    ])
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("h4", null, "Data: " + _toDisplayString(_ctx.datetimepicker.dt), 1),
                    _createElementVNode("div", null, [
                        _createVNode(_component_DatetimePicker, {
                            modelValue: _ctx.datetimepicker.dt,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.datetimepicker.dt) = $event)),
                            config: { format: 'DD/MM/YYYY' }
                        }, null, 8, ["modelValue"])
                    ])
                ]),
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("h4", null, "Hora: " + _toDisplayString(_ctx.datetimepicker.hr), 1),
                    _createElementVNode("div", null, [
                        _createVNode(_component_DatetimePicker, {
                            modelValue: _ctx.datetimepicker.hr,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.datetimepicker.hr) = $event)),
                            config: { format: 'HH:mm' }
                        }, null, 8, ["modelValue"])
                    ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("h4", null, "Dthr+s: " + _toDisplayString(_ctx.datetimepicker.dthrs), 1),
                    _createElementVNode("div", null, [
                        _createVNode(_component_DatetimePicker, {
                            modelValue: _ctx.datetimepicker.dthrs,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.datetimepicker.dthrs) = $event)),
                            config: { format: 'DD/MM/YYYY HH:mm:ss' }
                        }, null, 8, ["modelValue"])
                    ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("h4", null, "Change: " + _toDisplayString(_ctx.datetimepicker.dthrChange), 1),
                    _createElementVNode("div", null, [
                        _createVNode(_component_DatetimePicker, {
                            modelValue: _ctx.datetimepicker.dthrChange,
                            "onUpdate:modelValue": [
                                _cache[4] || (_cache[4] = ($event) => ((_ctx.datetimepicker.dthrChange) = $event)),
                                _cache[6] || (_cache[6] = ($event) => (_ctx.datepickerVueChange($event)))
                            ],
                            onDpChange: _cache[5] || (_cache[5] = ($event) => (_ctx.datepickerChange($event)))
                        }, null, 8, ["modelValue"])
                    ])
                ])
            ])
        ]),
        _createElementVNode("fieldset", null, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("h4", null, "Simples: " + _toDisplayString(_ctx.select2.myValue), 1),
                    _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                            _createVNode(_component_Select2, {
                                modelValue: _ctx.select2.myValue,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.select2.myValue) = $event)),
                                options: _ctx.select2.myOptions
                            }, null, 8, ["modelValue", "options"])
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-primary btn-block",
                                onClick: _cache[8] || (_cache[8] = ($event) => (_ctx.select2.myValue = 'op2'))
                            }, " Definir \"op2\" ")
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("h4", null, "Ajax: " + _toDisplayString(_ctx.select2.ajaxValue), 1),
                    _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                            _createVNode(_component_Select2, {
                                modelValue: _ctx.select2.ajaxValue,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.select2.ajaxValue) = $event)),
                                options: _ctx.select2.ajaxOptions,
                                settings: _ctx.select2.settings
                            }, null, 8, ["modelValue", "options", "settings"])
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-primary btn-block",
                                onClick: _cache[10] || (_cache[10] = ($event) => (_ctx.definirAjax15()))
                            }, " Definir \"15\" ")
                        ])
                    ])
                ])
            ])
        ]),
        _createElementVNode("fieldset", null, [
            _hoisted_18,
            _createElementVNode("h4", null, "Simples: " + _toDisplayString(_ctx.vtoggle.model), 1),
            _createVNode(_component_VToggle, {
                modelValue: _ctx.vtoggle.model,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.vtoggle.model) = $event))
            }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("fieldset", null, [
            _hoisted_19,
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_SummernoteEditor, {
                        modelValue: _ctx.summernote.model,
                        "onUpdate:modelValue": [
                            _cache[12] || (_cache[12] = ($event) => ((_ctx.summernote.model) = $event)),
                            _cache[13] || (_cache[13] = ($event) => (_ctx.summernoteChange($event)))
                        ],
                        onSummernoteImageLinkInsert: _ctx.summernoteImageLinkInsert
                    }, null, 8, ["modelValue", "onSummernoteImageLinkInsert"])
                ]),
                _createElementVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _createTextVNode(" " + _toDisplayString(_ctx.summernote.model) + " ", 1),
                    _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-primary",
                        onClick: _cache[14] || (_cache[14] = ($event) => (_ctx.summernote.model = '<p>teste</p>'))
                    }, " Definir texto ")
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
                _createElementVNode("fieldset", null, [
                    _hoisted_27,
                    _createElementVNode("div", _hoisted_28, [
                        _createVNode(_component_VariaveisTemplate, {
                            variaveis: _ctx.variaveisTemplate.variaveis,
                            "exibir-ajuda": false
                        }, null, 8, ["variaveis"])
                    ])
                ])
            ]),
            _createElementVNode("div", _hoisted_29, [
                _createElementVNode("fieldset", null, [
                    _hoisted_30,
                    _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("label", null, "Decimal: " + _toDisplayString(_ctx.inputs.decimal), 1),
                            _createElementVNode("div", _hoisted_33, [
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((_ctx.inputs.decimal) = $event))
                                }, null, 512), [
                                    [_directive_input_format, 'decimal'],
                                    [_vModelText, _ctx.inputs.decimal]
                                ]),
                                _createElementVNode("div", _hoisted_34, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "btn btn-primary",
                                        onClick: _cache[16] || (_cache[16] = ($event) => (_ctx.inputs.decimal = '1,50'))
                                    }, " Setar 1,50 ")
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("label", null, "Moeda: " + _toDisplayString(_ctx.inputs.moeda), 1),
                            _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "form-control",
                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((_ctx.inputs.moeda) = $event))
                            }, null, 512), [
                                [_directive_input_format, 'moeda'],
                                [_vModelText, _ctx.inputs.moeda]
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("label", null, "Inteiro: " + _toDisplayString(_ctx.inputs.inteiro), 1),
                            _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "form-control",
                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((_ctx.inputs.inteiro) = $event))
                            }, null, 512), [
                                [_directive_input_format, 'inteiro'],
                                [_vModelText, _ctx.inputs.inteiro]
                            ])
                        ])
                    ])
                ])
            ])
        ])
    ], 64));
}
